/*global MatchRendering */
const MatchSocket = function() {
    const lastScorePushes = [];
    const lastStatusPushes = [];

    function applyScoreUpdate(msg) {
        if (!msg.score_current) {
            return;
        }
        MatchRendering.updateScore(msg.score_current);
    }

    function applyStatusUpdate(msg) {
        if (msg.state_id == 7 && !msg.current_minute) {
            return; // nothing we can do about penalties yet
        }
        MatchRendering.updateStatus(msg.state_id, msg.current_minute, msg.injury_time_elapsed);
    }

    return {
        init: function(matchId) {
            const socket = io('/match-' + matchId, {
                reconnection: true,
                reconnectionDelay: 1000,
                reconnectionDelayMax : 3000,
                reconnectionAttempts: Infinity
            });

            socket.on('updates.score', function(data) {
                const msg = JSON.parse(data);
                lastScorePushes.push(msg);
                applyScoreUpdate(msg);
            });

            socket.on('updates.status', function(data) {
                const msg = JSON.parse(data);
                lastStatusPushes.push(msg);
                applyStatusUpdate(msg);
            });
        },
        reapplySocketUpdates: function() {
            for (const msg of lastScorePushes) {
                const polledLastChange  = $('.score-list-header__current strong').data('last-score-change');
                if (!polledLastChange || msg.last_score_change > polledLastChange) {
                    applyScoreUpdate(msg);
                }
            }
            for (const msg of lastStatusPushes) {
                const polledLastChange = $('.score-list-header__current .score-list-header__info').data('last-status-change');
                if (!polledLastChange || msg.last_status_change > polledLastChange) {
                    applyStatusUpdate(msg);
                }
            }
        }
    };
}();
